<template>
  <div
    class="minheight100 posterbg"
    style="padding-bottom: 130px"
    :class="{ 'bg-grey': dataDetail && dataDetail.activityStatus > 1 }"
  >
    <app-header v-if="appUser.isNative" title="友邻少年"></app-header>
    <template v-if="dataDetail">
      <div class="my-swiper">
        <swiper :options="swiperOption" ref="mySwiper" class="swiper" @slideChange="onSlideChange">
          <swiper-slide v-for="(item, index) in dataDetail.shareImgUrlList" :key="index" class="swiper_item">
            <div :id="'capture' + index" style="height: 100%" v-if="item.picUrl">
              <img :src="item.picUrl" @load="onImageLoad()" />
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </template>
    <div class="fixed-bottom" v-if="dataDetail && dataDetail.activityStatus !== 3">
      <div class="flexdiv average">
        <div v-if="dataDetail.showRecommendCode === 1" class="txt-center" style="margin-right: 20px" @click="tuijianma">
          <img style="width: 30px" src="./images/qrcode_small.png" />
          <p>推荐码</p>
        </div>
        <div class="btn-common block" @click="generatePoster">生成我的专属海报</div>
      </div>
    </div>
    <div class="dialog-mask" v-if="dialogShow">
      <div :class="{ 'sharetxt-con': dataDetail.showRecommends === 1 }">
        <div class="my-swiper" v-if="qrImgpath">
          <div class="poster-main">
            <div class="poster-show" v-show="posterObj.picUrl && qrImgpath" id="poster">
              <img
                style="position: absolute; z-index: 100; top: 0; left: 0; opacity: 0"
                class="cover"
                crossorigin="anonymous"
                :src="posterObj.canvasUrl"
                alt=""
              />
              <img :src="posterObj.picUrl" @load="onImageLoad()" crossorigin="anonymous" class="img" />
              <div class="qrcode" v-if="qrImgpath">
                <img :src="qrImgpath" />
              </div>
            </div>
          </div>

          <div class="swiper-pagination" slot="pagination"></div>
          <div class="longpress">
            <span class="icon-zhiwen"></span>
            长按并保存图片，分享至朋友圈
          </div>
          <div class="dialog-close top-right" style="bottom: -80px; opacity: 0.8" @click="dialogShow = false">×</div>
        </div>
        <div class="sharetxt" v-if="dataDetail.showRecommends === 1">
          <div class="stxt">
            <div class="share-container">
              <div class="stit flexdiv average">
                <h3>推荐语</h3>
                <span @click="refresh()" v-if="this.dataDetail.recommends && this.dataDetail.recommends.length > 1">
                  <i class="icon icon-refresh"></i>
                  换一个
                </span>
              </div>
              <div class="stxtcon">
                <div v-if="shareTxt">{{ shareTxt }}</div>
              </div>
            </div>
          </div>
          <div class="btn-common" @click="copyText($event)">复制推荐语</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { mapGetters } from 'vuex'
import html2canvas from 'html2canvas'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { activityService } from '@/api'
import QRCode from 'qrcode'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Dialog } from 'vant'
import { appUser } from '@/utils'
import { saTrack } from '@/utils/common/shence'
import copyText from '@/utils/clipboard'
import { MessageBox } from 'mint-ui'

const action = 'activityIndex'

export default {
  name: '',
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide,
    'van-dialog': Dialog.Component
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  data() {
    return {
      appUser,
      title: '',
      shareUserId: appUser.userId,
      dialogShow: false,
      shareLoading: false,
      dataDetail: null,
      dataShareDetail: null,
      posterObj: null,
      qrImgpath: '',
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        loop: false,
        autoplay: false, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false
        }
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'fraction'
        // },
      },
      swiperIndex: 0,
      shareTxt: '',
      shareTxtIndex: 0
    }
  },
  mixins: [Body],

  created() {
    console.log('进来活动created了')
    //https://new-wx.ylyk.com/test/ylyk/payment.html#/activity?shareCode=15
    this.shareUserId = appUser.userId
    console.log(appUser.userId)
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData()
    // this.getDataShare()
  },
  mounted() {},
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.getData()
        // this.getDataShare()
      })
    },
    //活动概览
    getData() {
      activityService
        .activityDetail({
          shareCode: this.shareCode
        })
        .then(res => {
          this.dataDetail = res
          this.refresh('init')
          if (res) this.title = this.dataDetail.activityName
        })
    },
    //获取分享海报
    getDataShare() {
      if (!this.shareUserId) return
      activityService
        .activityShare({
          shareCode: this.shareCode,
          shareUserId: this.shareUserId,
          picId: this.dataDetail.shareImgUrlList[this.swiperIndex].picId
        })
        .then(res => {
          this.dataShareDetail = res
          this.posterObj = res.shareImgUrlList[0]
          this.posterObj.canvasUrl = ''
          try {
            //神策数据埋点
            saTrack('invitePosterCreateClick', {
              activity_id: this.dataDetail.activityId,
              poster_id: this.posterObj.picId,
              operator: '用户本人',
              poster_name: this.posterObj.picName,
              salesman_id: this.dataShareDetail.adminShareUserId
            })
          } catch (err) {}
          this.makeQRcode()
        })
        .catch(err => {
          this.$toast(err.data.returnMsg)
          Toast.clear()
          this.dialogShow = false
        })
    },
    // 设置分享数据
    setShareData() {
      if (this.dataDetail && this.dataDetail.shareMainTitle) {
        return {
          title: this.dataDetail.shareMainTitle,
          desc: this.dataDetail.shareSecondTitle,
          link: location.href,
          imgUrl: this.dataDetail.shareImg
        }
      }
    },
    tuijianma() {
      this.$router.push({
        name: 'activityRecommend',
        query: { activityId: this.dataDetail.activityId }
      })
    },
    //生成海报
    generatePoster() {
      this.getDataShare()
      if (!this.checkStatus()) return
      if (this.dataDetail.activityStatus === 2) {
        this.$toast('活动已结束！')
        return
      }

      this.dialogShow = true
      //生成图片结束关闭Toast.clear()
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      })

      //五秒钟后关闭Toast
      setTimeout(() => {
        Toast.clear()
      }, 6000)
    },
    checkStatus() {
      if (!this.dataDetail || this.dataDetail.activityStatus === 0) {
        this.$toast('活动未开始！')
        return false
      }
      return true
    },
    //生成二维码
    makeQRcode() {
      let shareQrContent = this.posterObj.shareUrl
      if (!shareQrContent) return
      const opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 1
      }
      QRCode.toDataURL(shareQrContent, opts).then(url => {
        this.qrImgpath = url
      })
    },
    onImageLoad() {
      this.createImage()
    },
    createImage() {
      try {
        const capture = document.getElementById('poster')
        html2canvas(capture, {
          background: null,
          useCORS: true,
          width: capture.offsetWidth - 2,
          height: capture.offsetHeight - 3,
          scrollX: 0,
          scrollY: 0,
          scale: 3
        })
          .then(canvas => {
            // document.body.appendChild(canvas)
            const dataURL = canvas.toDataURL('image/png')
            this.$set(this.posterObj, 'canvasUrl', dataURL)
            console.log(this.posterObj.canvasUrl, 'posterObj.canvasUrl')
            this.$forceUpdate()
          })
          .finally(() => {
            console.log('生成结束')
            Toast.clear()
          })
      } catch (err) {
        Toast.clear()
      }
    },
    onSlideChange() {
      this.swiperIndex = this.$refs.mySwiper.swiper.realIndex
      this.qrImgpath = ''
    },
    copyText(event) {
      copyText(this.shareTxt, event)
      try {
        //神策数据埋点
        saTrack('recommend_copywriting_click', {
          activity_id: this.dataDetail.activityId,
          copywriting: this.shareTxt,
          operator: '用户本人',
          salesman_id: this.dataShareDetail.adminShareUserId
        })
      } catch (err) {}
      MessageBox({
        title: '',
        message: '推荐语复制成功，长按保存海报一起分享至朋友圈吧~',
        confirmButtonText: '我知道了',
        confirmButtonClass: 'button-i_see'
      }).then(() => {})
    },
    //刷新换一个
    refresh(type) {
      if (this.dataDetail.recommends && this.dataDetail.recommends.length === 0) return
      this.shareTxt = ''

      if (type === 'init') {
        this.shareTxtIndex = 0
      } else {
        this.shareTxtIndex =
          this.shareTxtIndex + 1 === this.dataDetail.recommends.length
            ? (this.shareTxtIndex = 0)
            : this.shareTxtIndex + 1
      }
      this.shareTxt = this.dataDetail.recommends[this.shareTxtIndex]
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';

.my-swiper {
  position: absolute;
  width: 100vw;
  height: 70vh;
  top: 50%;
  margin-top: -40vh;
}

.swiper-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  .swiper-wrapper .swiper-slide {
    width: 42vh;
    border-radius: 8px;
    overflow: hidden;
    transform: none !important;
    height: 65vh;
    margin-top: 2.5vh;
    pointer-events: none;
  }
  .swiper-slide-active {
    height: 100% !important;
    margin-top: 0 !important;
  }
  .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .swiper-pagination {
    font-size: 28px;
    color: #8a91a4;
    bottom: -80px !important;
  }
}

.qrcode {
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #000;
  width: 80px;
  height: 80px;
  background-color: #fff;
}
.explain {
  position: fixed;
  top: 40px;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  padding: 8px 10px 8px 16px;
  color: #fff;
}
.posterbg {
  background: hwb(181 15% 65%) url('./images/posterbg.png') no-repeat;
  background-position: 0 0;
  background-size: 100% 95%;
}
.poster-main {
  border-radius: 4px;
  position: relative;
  height: 100%;
  width: 33vh;
  text-align: center;
  margin: 0 auto;
  overflow: hidden;
}
.poster-show {
  position: relative;
  .qrcode {
    width: 8vh;
    height: 8vh;
  }
  img {
    height: 100%;
    width: 100%;
  }
}

.sharetxt-con {
  .qrcode {
    width: 8vh;
    height: 8vh;
  }
  .dialog-close {
    top: 0 !important;
    right: 45px !important;
  }
  .my-swiper {
    height: 55vh;
    margin-top: -5vh;
    top: 10vh;
    z-index: 100;
  }
  .poster-show {
    width: 33vh;
  }
  .sharetxt {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 20px;
    z-index: 1;

    .stxt {
      background: url('./images/sharetxt_bg.png');
      background-size: 100% 100%;
      height: 32vh;
      margin: -8px -8px 10px -8px;
      position: relative;
    }
    .share-container {
      position: absolute;
      bottom: 2vh;
      left: 20px;
      right: 20px;
    }
    .stit {
      color: #fff;
      margin-bottom: 5px;
      span {
        font-size: 12px;
      }
    }
    .icon-refresh {
      background: url('./images/icon_refresh.png') no-repeat;
      background-size: 100% auto;
      display: inline-block;
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-top: -3px;
    }
    .stxtcon {
      background-color: #fff;
      border-radius: 8px;
      padding: 10px 10px 8px;
      min-height: 108px;
      font-size: 12px;
      line-height: 18px;
      user-select: auto !important;
    }
  }
}
.explain-con {
  border: 5px solid #366c6d;
  border-radius: 8px;
  position: relative;
  height: 80vh;
  margin: 0 20px;
  margin-top: 10vh;
  background: #fff;
  padding: 45px 0px 76px;
  .title {
    position: absolute;
    top: -9px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 120px;
    height: 50px;
    line-height: 42px;
    text-align: center;
    background: url('./images/rule_title_bg.png') no-repeat;
    background-size: 100% auto;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
  .container {
    padding: 0 20px;
    line-height: 22px;
    height: 100%;
    overflow-y: auto;
  }
  .myrule {
    h3 {
      margin-top: 16px;
      margin-bottom: 5px;
      font-size: 16px;
    }
    p {
      font-size: 14px;
      color: #555;
    }
  }
  .know {
    position: absolute;
    background-color: #fff;
    bottom: 0;
    width: 100%;
    padding: 16px;
  }
}
</style>
<style lang="scss">
// .mint-msgbox {
//   .mint-msgbox-btn.button-i_see {
//     background-color: #366c6d;
//     color: #fff;
//   }
// }
</style>
